export default [
    {
        path: '/equipment/:id',
        name: 'equipment',
        component: () => import('@/views/equipment/EquipmentView.vue'),
    },
];
